import { StoreFulfillmentFilterOption, StoreFulfillmentPresentation } from './models';

import { StoreFulfillmentType } from '@/server/services/vendor/stores/models';
import { Home2, Setting2, Shop, TruckFast } from 'iconsax-react';

/** Showcase size: enough to swipe through; the full list lives in the stores directory. The CMS `pageSize` is clamped to this range. */
export const HOME_STORES_MIN_SIZE = 8;
export const HOME_STORES_MAX_SIZE = 12;

export const HOME_STORE_FULFILLMENT_OPTIONS: StoreFulfillmentFilterOption[] = [
    { value: '', title: 'همه' },
    { value: 'INSTALL_CENTER', title: 'تعویض در اتوسرویس' },
    { value: 'INSTALL_ONSITE', title: 'تعویض در محل' },
    { value: 'SHIPPING', title: 'ارسال کالا' },
    { value: 'PICKUP_CENTER', title: 'تحویل حضوری' }
];

export const HOME_STORE_FULFILLMENT_PRESENTATION: Record<StoreFulfillmentType, StoreFulfillmentPresentation> = {
    INSTALL_CENTER: { title: 'تعویض در اتوسرویس', Icon: Setting2 },
    INSTALL_ONSITE: { title: 'تعویض در محل', Icon: Home2 },
    SHIPPING: { title: 'ارسال کالا', Icon: TruckFast },
    PICKUP_CENTER: { title: 'تحویل حضوری', Icon: Shop }
};
